import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import useMediaQuery from "@mui/material/useMediaQuery";
import MobileMenu from "./MobileMenu";
import Header from "./Header";
import DesktopMenu from "./DesktopMenu";
import ExercisePromoModal from "@features/exercises/modals/ExercisePromoModal";
import NewProgramFab from "@features/programs/components/NewProgramFab";
import { useExercisePromo } from "@features/exercises/hooks/useExercisePromo";
import { logoutSession } from "@/services/sessionApi";
import "./Menu.css";

/** Routes whose content column scrolls itself — see isSelfScrollingRoute. */
const SELF_SCROLLING_ROUTES = ["/patients", "/exercises", "/programs/create"];

/**
 * Whether this route's own column owns the scrolling, so the shell must not
 * scroll as well.
 *
 * Exported for the test: the previous version of this rule read the page's
 * component name, which stopped matching when the routes became lazy and
 * failed silently — the sidebar scrolled away with the content and the
 * back-to-top button never appeared.
 */
export function isSelfScrollingRoute(pathname = "") {
  return SELF_SCROLLING_ROUTES.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`)
  );
}

export default function AppLayout(props) {
  const { pathname } = useLocation();
  const isMobile = useMediaQuery("(max-width:900px)");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showPromoModal, handlePromoModalClose] = useExercisePromo();

  const logout = () => {
    logoutSession();
    localStorage.removeItem("access_token");
    window.location.reload();
  };

  const handleBurgerClick = () => {
    setIsMobileMenuOpen(true);
  };

  const handleMobileMenuClose = () => {
    setIsMobileMenuOpen(false);
  };

  /* This used to be read off props.content.type.name. Since the routes became
     lazy every page renders as "LazyPage", so none of those names matched any
     more and only a /programs/create path check still did anything. */
  const isHiddenOverflow = isSelfScrollingRoute(pathname);

  var menu = isMobile ? (
    <Container fluid className="px-0">
      <Row className="g-0">
        <Col className="px-0">
          <div className="program-overview">{props.content}</div>
          <MobileMenu 
            isOpen={isMobileMenuOpen} 
            onClose={handleMobileMenuClose} 
            logout={logout}
          />
        </Col>
      </Row>
    </Container>
  ) : (
    <DesktopMenu content={props.content} isHiddenOverflow={isHiddenOverflow} logout={logout} />
  );

  return (
    <>
      <Header logout={logout} onBurgerClick={handleBurgerClick} />
      {menu}
      <NewProgramFab />
      <ExercisePromoModal show={showPromoModal} onHide={handlePromoModalClose} />
    </>
  );
}



